import {
  EQUIPMENT,
  EXERCISE_ACTIVITY_FILTERS,
  EXERCISE_CATEGORIES,
  EXERCISE_DIFFICULTIES,
  EXERCISE_MEDIA_FILTERS,
  EXERCISE_SOURCE_FILTERS,
  MUSCLE_GROUPS,
} from '@steado/admin-contract/exercises';
import { z } from 'zod';

/**
 * Filters and the paging cursor live in the URL, so "every push movement still
 * missing a clip" is a link rather than a set of clicks to repeat. Every field
 * `.catch(undefined)`, so a stale bookmark degrades to the unfiltered library
 * instead of an error page — including one written when opening an exercise
 * was `?exercise=` rather than a page of its own.
 */
export const exercisesSearchSchema = z.object({
  search: z.string().trim().min(1).max(120).optional().catch(undefined),
  category: z.enum(EXERCISE_CATEGORIES).optional().catch(undefined),
  difficulty: z.enum(EXERCISE_DIFFICULTIES).optional().catch(undefined),
  equipment: z.enum(EQUIPMENT).optional().catch(undefined),
  muscle: z.enum(MUSCLE_GROUPS).optional().catch(undefined),
  activity: z.enum(EXERCISE_ACTIVITY_FILTERS).optional().catch(undefined),
  /** Paired with `activity: 'inactive'` this is the import review queue. */
  source: z.enum(EXERCISE_SOURCE_FILTERS).optional().catch(undefined),
  media: z.enum(EXERCISE_MEDIA_FILTERS).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type ExercisesSearch = z.infer<typeof exercisesSearchSchema>;
